import { useEffect, useState } from "react";
import { LogIn } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Route } from "react-router-dom";

import { FullscreenLoading } from "@/components/FullscreenLoading";
import LoggedOutMainNavigation from "@/components/LoggedOutMainNavigation";
import { WFPButton } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ACCOUNT_DELETION_PATH } from "@/constants";
import { isTokenExpired, setupClient, startCiamLogin } from "@/utils/authentication";
import { AccountDeletionRouteProps } from "./types";

type AuthStatus = "loading" | "loggedIn" | "loggedOut";

export const AccountDeletionRoute = ({ component, path, exact }: AccountDeletionRouteProps) => {
  const { t } = useTranslation();
  const [status, setStatus] = useState<AuthStatus>("loading");

  useEffect(() => {
    const ciamAccessToken = localStorage.getItem("ciam_access_token");
    const userProfile = localStorage.getItem("user_profile");
    const expiryDate = new Date(localStorage.getItem("expiry_date") ?? 0);

    if (!ciamAccessToken || !userProfile || isTokenExpired(expiryDate)) {
      setStatus("loggedOut");
      return;
    }

    setupClient(ciamAccessToken);
    setStatus("loggedIn");
  }, []);

  if (status === "loading") {
    return <FullscreenLoading isVisible />;
  }

  return (
    <>
      <LoggedOutMainNavigation />
      {status === "loggedIn" ? (
        <Route exact={exact} path={path} component={component} />
      ) : (
        <div className="mx-auto my-8 w-full max-w-3xl px-4">
          <Card>
            <CardContent className="space-y-6">
              <h1 className="text-center font-bold text-2xl">{t("accountDeletion.title")}</h1>
              <div className="space-y-2">
                <p className="font-bold">{t("accountDeletion.login.title")}</p>
                <p>{t("accountDeletion.login.description")}</p>
              </div>
              <div className="flex justify-center">
                <WFPButton onClick={() => startCiamLogin(ACCOUNT_DELETION_PATH)}>
                  <LogIn />
                  {t("accountDeletion.login.button")}
                </WFPButton>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </>
  );
};
